import React, { Component } from 'react';
import { Route, withRouter } from "react-router-dom";
import SimplePopover from '../SimplePopover';

import AdaptativaHeader from '../AdaptativaHeader';
import Acompanhamento from './acompanhamento/Acompanhamento';

class AdminPage extends Component {

    getActiveTab(defaultRoute) {
        var path = (defaultRoute || this.props.location.pathname).toLowerCase();

        if (path === "/app/acompanhamento") { return { title: "Acompanhamento", backgroundClassName: " adap-yellow ", borderClassName: " adap-border-yellow " }; }

        //Se não está em nenhuma das rotas anteriores, retorna a aba padrão
        return this.getActiveTab("/app/acompanhamento");
    }

    render() {
        return (
            <div >
                <AdaptativaHeader />


                {/* Navegação das Abas Dektop */}
                <div className={"edb-hide-small edb-hide-medium edb-margin-top edb-bottombar-small " + this.getActiveTab().borderClassName}>
                    <a className="edb-btn adap-yellow" href="#/app/acompanhamento">&nbsp;Acompanhamento&nbsp;</a>
                    <button className="edb-btn adap-blue edb-lock" href="#/app/biblioteca" title="Em breve">Biblioteca de Conteúdo</button>
                </div>

                {/* Navegação das Abas Mobile */}
                <div className={"edb-hide-large edb-hide-large edb-center" + this.getActiveTab().backgroundClassName}>

                    <SimplePopover noPadding={true} content={<div className="edb-bar-block" style={{ width: "300px" }}>
                        <a className="edb-bar-item edb-button edb-medium " href="#/app/acompanhamento">&nbsp;Acompanhamento&nbsp;</a>
                        <button className="edb-bar-item edb-button edb-medium edb-lock" href="#/app/biblioteca" title="Em breve">Biblioteca de Conteúdo</button>
                    </div>}>
                        <div className="edb-btn" style={{ width: "300px" }}>
                            <span className="edb-large edb-text-bold adap-text-white">{this.getActiveTab().title}</span>
                            <i className="fas fa-chevron-down edb-margin-left adap-text-white"></i>
                        </div>
                    </SimplePopover>
                </div>

                <div className="adap-mobile-container">

                    {/* Aba padrão */}
                    <Route exact path="/app" component={Acompanhamento} />

                    {/* Abas */}
                    <Route path="/app/acompanhamento" component={Acompanhamento} />

                </div>
            </div>
        );
    }
}

export default withRouter(props => <AdminPage {...props} />);